
<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable>
    <template v-slot:activator="{ props }">
      <v-btn
             color="primary"
             :class="{ 'float-right': floatRight }"
             v-bind="props"
             @click="editMember.legal_person_id = null"><v-icon class="mr-2">mdi-account-plus</v-icon> Incluir
        membro</v-btn>
    </template>
    <v-card v-if="group && group.id">
      <v-toolbar color="primary" :title="`[${group.acronym}] - ${group.name}`">
        <v-btn color="black" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12">
            <AutocompleteSelectCreateLegalPerson
                                                 :group_id="group.id"
                                                 :user="user"
                                                 v-model="editMember.legal_person"
                                                 @selected="selectedLegalPerson"
                                                 label="Selecione o novo membro" />
          </v-col>
          <!-- <v-col cols="12" md="6">
            <v-autocomplete
              label="Função do membro / permissões"
              v-model="editMember.role"
              item-title="label"
              item-value="value"
              :items="$GROUP_ROLES"
            >
    <template v-slot:no-data>
      <div class="px-4">Digite sua busca</div>
    </template></v-autocomplete
  >
          </v-col> -->
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn variant="text" color="error" @click="dialog = false">Cancelar</v-btn>
        <v-btn variant="text" color="success" @click="submitUpdate">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import AutocompleteSelectCreateLegalPerson from "./AutocompleteSelectCreateLegalPerson.vue";
import FormGroup from "./FormGroup.vue";
import api from '@/services'
export default {
  components: { FormGroup, AutocompleteSelectCreateLegalPerson },
  props: {
    user: Object,
    floatRight: Boolean,
    group: Object,
    dialogStatus: Boolean,
    member: Object,
  },
  data() {
    return {
      requestingApi: false,
      editMember: {
        group_id: null,
        legal_person_id: null,
        legal_person: null,
        role: 0,
      },
      dialog: false,
      searchText: null,
      preciousSearch: null,
      loading: false,
      lstObjects: [],
      timeoutSearchDelay: null,
    };
  },
  mounted() {
    var vm = this;
    if (vm.member && vm.member?.id) {
      vm.editMember = vm.member;
    }
  },
  activated() { },
  methods: {
    selectedLegalPerson(legalPerson) {
      var vm = this;

      vm.editMember.legal_person_id = legalPerson?.id;
      if (legalPerson.user.access_level >= 500) {
        vm.editMember.role = 7;
      } else {
        vm.editMember.role = 0;
      }
    },
    submitUpdate() {
      var vm = this;
      vm.editMember.group_id = vm.group.id;
      if (!vm.editMember.legal_person_id) {
        vm.$notify({
          type: "warn",
          text: "Selecione um membro",
        });
        return;
      } else {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.groupMember
            .update(vm.editMember)
            .then((result) => {
              vm.$emit("updated", {
                ...vm.editMember,
                ...result,
              });
              vm.editMember = {
                group_id: null,
                legal_person_id: null,
                role: 0,
              };
              vm.$notify({
                type: "success",
                text: "Membro inserido com sucesso",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    waitAndSearch() {
      var vm = this;
      if (vm.timeoutSearchDelay) {
        clearTimeout(vm.timeoutSearchDelay);
      }
      if (vm.searchText != "" && vm.searchText != " ") {
        vm.timeoutSearchDelay = setTimeout(() => {
          vm.submitSearch();
        }, 1500);
        vm.loading = true;
      }
    },
    customFilter(item, queryText, itemText) {
      return true;
    },
    submitSearch(page) {
      var vm = this;
      if (!vm.requestingApi) {
        let _searchText = vm.searchText;
        let _prev = (vm.preciousSearch || "").toUpperCase();
        let _act = (_searchText || "").toUpperCase();
        if (_act == "" || (_act == " " && _prev == _act)) {
          vm.loading = false;
          return;
        }
        vm.requestingApi = true;
        vm.page = page || 1;
        return new Promise((resolve, reject) => {
          api.legalPerson
            .search({ searchText: _searchText })
            .then((result) => {
              vm.preciousSearch = _searchText;
              vm.lstObjects = result;
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
              vm.loading = false;
            });
        });
      }
    },
  },
  computed: {},
  watch: {
    dialog(newVal) {
      if (!newVal) {
        this.$emit("closed");
      }
    },
    "editMember.legal_person"(newVal) {
      if (!newVal) {
        this.editMember.legal_person_id = null;
      } else {
        this.editMember.legal_person_id = newVal?.id;
      }
    },
    dialogStatus(newVal) {
      if (newVal) {
        this.dialog = true;
      }
    },
    member(newVal) {
      this.editMember = newVal;
    },
    searchText(newVal, oldVal) {
      if (
        newVal &&
        newVal != " " &&
        newVal.toUpperCase() != oldVal.toUpperCase()
      ) {
        this.waitAndSearch();
      }
    },
  },
};
</script>
